<template>
    <div>
        <div class="offcanvas offcanvas-start" tabindex="-1" id="appSelectorBar" aria-labelledby="appSelectorBarLabel" style="width: 20%">
            <div class="offcanvas-header bg-black">
                <div v-if="!loading">
                    <h4 class="offcanvas-title text-info fw-light" id="appSelectorBarLabel">A p p s</h4>
                </div>
                <div v-if="loading" style="display: flex;">
                    <h4 class="offcanvas-title text-white fw-light" id="appSelectorBarLabel">Loading App</h4>
                    <div class="spinner-border ms-3 mt-1" style="width: 2rem; height: 2rem; color: Blue;" role="status"></div>
                </div>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body" style="background-color: rgb(0, 7, 18);">
                <div id="appsListContainer" class="text-center" :class="{'disabled-div': loading }">
                    <div v-show="Object.keys(apps).includes('suite')" class="btn bg-black text-center rounded mt-2" @click="moveRoute('suite')" :class="{'fa-fade': loading & selected == 'suite'}">
                        <img :src="require(`@/assets/minis/suite_mini.png`)" title="Suite" alt="Suite" width="200" height="200" class="img-fluid rounded border-0 hovering">
                    </div>
                    <div v-for="(_app, _app_name, _appi) in apps" v-bind:key="_appi">
                        <div v-if="_app_name != 'suite'">
                            <div class="btn bg-black text-center rounded mt-2" @click="moveRoute(`/${_app_name}`)" :class="{'fa-fade': loading & selected == _app_name}">
                                <img :src="require(`@/assets/minis/${_app_name}_mini.png`)" :title="`${capitalize(_app_name)}`" :alt="capitalize(_app_name)" width="200" height="200" class="img-fluid rounded border-0 hovering">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'AppSelectorBar',
    props: {},
    components: {},
    data(){
        return {
            loading: false,
            wantedApp: "",
            apps: {},
            selected: null
        }
    },
    methods: {
        capitalize(_string){
            const lower = _string.toLowerCase()
            return _string.charAt(0).toUpperCase() + lower.slice(1)
        },
        moveRoute(routeName){
            this.selected = routeName.replace('/','')
            // Formatting
            var routeName = routeName.replace('_','-')
            // Protection.
            const cr = String(this.$route.path).replace("/","")
            this.wantedApp = this.capitalize(routeName)
            if (cr != routeName){
                this.loading = true
                this.$router.push(routeName)
            }
            else {
                alert('You are already in ' + this.wantedApp + ".")
            }
        },
        getApps(apps){
            this.apps = apps
        }
    }
}
</script>

<style scoped>
    .disabled-div{
        pointer-events: none;
        opacity: 0.5;
    }

    .hovering{
        opacity: 1.0;
        transition-duration: 0.5s;
    }
    .hovering:hover{
        opacity: 0.5;
    }

    /* Scrollbar */
    /* width */
    ::-webkit-scrollbar {
        width: 10px;
        height: 7px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgb(37, 33, 33); 
        border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: rgb(47, 47, 47); 
        border-radius: 10px;
        transition-duration: 2.0s;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: rgb(65, 65, 65); 
    }

</style>